import dynamic from 'next/dynamic';

export const TourContainer = dynamic(() => import('./data-components/TourContainer'), { ssr: false });

export { default as useTour } from './hooks/useTour';
